import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useFlags } from "launchdarkly-react-client-sdk";
import ActionButton from "./ActionButton";
import ActionsList from "./ActionsList";
import { getMainActions } from "./NonRKPayInvoiceActionsConfig";
import { Loader } from "../../../../../../../components";

const NonRKPayToolbarMainActions = ({
    nonRKPayInvoiceDetailHook,
    isSuperAdmin,
    setShowSendRemindersModal,
    sendingInvoice,
    handleSend,
}) => {
    const { lang } = global;
	const { clientV4InvoicingDisputes } = useFlags();

	const { initialized } = nonRKPayInvoiceDetailHook;

	const mainActions = useMemo(
		() =>
		  initialized
			? getMainActions({
				nonRKPayInvoiceDetailHook,
				handleSend,
				sendingInvoice,
				lang,
				isSuperAdmin,
				setShowSendRemindersModal,
				clientV4InvoicingDisputes
			  })
			: [],
		[initialized, nonRKPayInvoiceDetailHook, sendingInvoice, clientV4InvoicingDisputes]
	);

    return !initialized
		? <Loader />
		: (
			<ActionsList
			actions={mainActions}
			ButtonComponent={ActionButton}
			/>
		);
};

NonRKPayToolbarMainActions.propTypes = {
    nonRKPayInvoiceDetailHook: PropTypes.object.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    setShowSendRemindersModal: PropTypes.func.isRequired,
    sendingInvoice: PropTypes.bool,
    handleSend: PropTypes.func,
};

NonRKPayToolbarMainActions.defaultProps = {
    handleSend: () => {},
    sendingInvoice: false,
};

export default NonRKPayToolbarMainActions;
